export const homeObjOne = {
    lightBg: false,
    primary: true, 
    imgStart: '', 
    lightTopLine: true,
    lightTextDesc: true,
    buttonLabel: 'Get Started',
    description: 'We have help business appear to larger demographic, by building their websites which will lead to an increase in visibility and revenue.',
    headline: 'Online visibility to customers leads to revenue increase', 
    lightText: true,
    topLine: 'Web Development',
    alt: 'image',
    img: require('../../images/image1.svg').default,
    start: ''
}

export const homeObjTwo = {
    lightBg: true,
    primary: false,
    imgStart: 'start', 
    lightTopLine: false,
    lightTextDesc: false,
    buttonLabel: 'Get Started',
    description: 'We are passionate about bringing clients’ ideas to life. Since our founding in 2018, our mission has been to do exceptional work, build great relationships, collaborate with great minds, and keep learning.',
    headline: 'Affordable Packages ranges from R1500 to R2500', 
    lightText: false,
    topLine: 'E-Commerce',
    alt: 'image',
    img: require('../../images/profile.jpg').default,
    start: 'true'
}

export const homeObjThree = {
    lightBg: false,
    primary: true,  
    imgStart: '', 
    lightTopLine: true,
    lightTextDesc: true,
    buttonLabel: 'Get Started',
    description: 'Our focus is to offer beautiful professioanl affordable websites that works, websites that help your business grow online.',
    headline: 'Friendly User Experience', 
    lightText: true,
    topLine: 'Mobile Applications',
    alt: 'image',
    img: require('../../images/image2.svg').default,
    start: ''
}

export const homeObjFour = {
    lightBg: false,
    primary: true, 
    imgStart: 'start', 
    lightTopLine: true,
    lightTextDesc: true,
    buttonLabel: 'Get Started',
    description: 'Our core focus is creating solutions for individuals and companies which position them at the forefront of technology.',
    headline: 'Optimized websites get visible on Search Engines.', 
    lightText: true,
    topLine: 'Development',
    alt: 'image',
    img: require('../../images/image3.svg').default,
    start: 'true'
}